import type {
  SasfinWealthOnlineBlModelsOnboardingOnboardingManagementView,
  SasfinWealthOnlineBlModelsPagedResultOfSasfinWealthOnlineBlModelsOnboardingOnboardingManagementView,
} from '../../generated/auth/models';

export type OnboardingManagementView = SasfinWealthOnlineBlModelsOnboardingOnboardingManagementView;
export type OnboardingPagedResult =
  SasfinWealthOnlineBlModelsPagedResultOfSasfinWealthOnlineBlModelsOnboardingOnboardingManagementView;

export interface OnboardingFilters {
  Search?: string;
  FirstName?: string;
  LastName?: string;
  CrmNumber?: string;
  IdentityOrPassport?: string;
  SortBy?: string;
  SortDescending?: boolean;
  Page?: number;
  PageSize?: number;
}

export interface OnboardingLoadParams extends OnboardingFilters {}

export const defaultOnboardingFilters: OnboardingFilters = {
  Search: '',
  FirstName: '',
  LastName: '',
  CrmNumber: '',
  IdentityOrPassport: '',
  SortBy: 'CreatedAt',
  SortDescending: true,
  Page: 1,
  PageSize: 10,
};

export const STORE_TYPE = 'ADVISOR-ONBOARDING';
